$(document).ready(function(){
  $("#see-more-tags").on("click", function(){
    let tags = $(".left-blog .blog-tags"); 
    for (let tag of tags){
     	tag.style.display = "inline-block"; 
    }
    $("#see-more-tags").addClass("invisible");
    $("#see-less-tags").removeClass("invisible");
  });
  
  $("#see-less-tags").on("click", function(){
    let tags = $(".left-blog .blog-tags"); 
    for (let tag = 8; tag < tags.length; tag++){
     	tags[tag].style.display = "none"; 
    }
    $("#see-less-tags").addClass("invisible");
    $("#see-more-tags").removeClass("invisible");
  });
});